import Immutable from 'immutable'

export function trimData(data) {
  return data.reduce((acc, value, key) => {
    if (typeof value === 'string' || typeof value === 'undefined') {
      return acc.set(key, value ? value.trim() : '')
    }

    return acc.set(key, value)
  }, Immutable.Map())
}
